import Vue from 'vue';
if (document.getElementById('organization-list')) {
    let organizationList = new Vue({
        el: "#organization-list",
        data: {
            organizations: {},
            page: 1,
            load: false,
            pageCount: 0,
            organizationQuery: '',
        },
        mounted: function () {
            this.fetchOrganizations();
        },
        methods: {
            fetchOrganizations: function (append) {
                var self = this;

                this.load = true;

                try {
                    var data = {name: this.organizationQuery};

                    $.extend(data, {page: this.page});

                    $.ajax({
                        url: '/api/v1/organization',
                        dataType: "json",
                        data: data,
                        success: function (data) {
                            if (append === true) {
                                $.each(data.items, function (i, item) {
                                    self.organizations.items.push(item);
                                });
                            } else {
                                self.organizations = data;
                                self.pageCount = data._meta.pageCount;
                                self.page = 1;

                            }
                            self.load = false;
                        },
                        fail: function () {
                            throw new Error('Ошибка получении данных');
                        }
                    });

                } catch (e) {
                    console.error(e);
                }
            },
            search: function () {
                var self = this;

                if (this.organizationQuery.length >= 3 || this.organizationQuery.length === 0) {
                    self.fetchOrganizations();
                }

            },
            nextPage: function () {

                this.page = this.page + 1;
                this.fetchOrganizations(true);

            }
        }
    });
}